<template>

  <div>

		<v-simple-table>
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">Descripción</th>
						<th class="text-right columna-60-100">Precio unitario</th>
						<th class="text-right columna-60-100">Cantidad</th>
						<th class="text-right columna-60-100">Impuestos</th>
						<th class="text-right columna-60-100">Precio total</th>
						<th style="max-width: 60px;"></th>
					</tr>
				</thead>
				<tbody v-if="datos.productos">
					<tr v-for="(p, i) in datos.productos" :key="`pdcto${i}`">
						<td>
							<div class="miniimagen-descripcion">
								<div class="miniimagen">
									<v-img
										v-if="p.imágenes && p.imágenes.principal.pequeña"
										:src="p.imágenes.principal.pequeña"
										max-height="40px"
										max-width="40px"
										contain
									>
									</v-img>
								</div>
								<p>{{ p.descripción }}</p>
							</div>
						</td>
						<td class="text-right columna-60-100">{{ moneda(p.precioUnitario) }}</td>
						<td class="columna-60-100">
							<v-text-field
								v-model="p.cantidad"
								type="number"
								min="1"
								:max="p.enInventario"
								class="cantidad-producto"
								:readonly="soloLectura"
							></v-text-field>
						</td>
						<td class="text-right columna-60-100">
							<div v-if="p.impuestos.length === 0" class="grey--text" style="font-size: 80%">
								(No se aplican impuestos)
							</div>
							<div v-else v-for="(impuesto, j) in p.impuestos" :key="`pdcto${i}-ipto${j}`">
								<v-select
									v-model="impuesto.porcentaje"
									:items="impuesto.alternativas"
									item-value="porcentaje"
									:label="impuesto.descripción.abreviada"
									:readonly="soloLectura || (impuesto.alternativas.length === 1 && impuesto.requerido && impuesto.porcentaje.length > 0)"
									hide-details
									dense
								>
								</v-select>
							</div>
						</td>
						<td class="text-right columna-60-100">{{ moneda(p.precioTotal) }}</td>
						<td style="max-width: 60px;">
							<v-tooltip bottom v-if="!soloLectura">
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon v-bind="attrs" v-on="on" @click="quitarProducto(i)"><v-icon>mdi-delete</v-icon></v-btn>
								</template>
      					<span>Quitar producto</span>
							</v-tooltip>
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
		<v-spacer></v-spacer>
		<div class="d-flex mt-3">
			<v-spacer></v-spacer>
			<table class="totales">
				<tbody>
					<tr>
						<td style="text-align: right">SUBTOTAL:</td>
						<td class="text-right">{{ moneda(subtotal) }}</td>
					</tr>
					<tr>
						<td style="text-align: right">IMPUESTOS:</td>
						<td class="text-right">{{ moneda(montoDeImpuestos) }}</td>
					</tr>
					<tr>
						<td style="text-align: right">TOTAL:</td>
						<td class="text-right">{{ moneda(total) }}</td>
					</tr>
				</tbody>
			</table>
		</div>

  </div>

</template>

<script>
import { facturasDeVenta, definicionesDeImpuestos } from '@/../../cliente_comun/fuentes'
import { notificación, moneda } from '@/../../cliente_comun/utilidades'

export default {
	name: 'factura-constructor-tabla',
	data: () => ({
		fuente: facturasDeVenta,
		definicionesDeImpuestos: definicionesDeImpuestos,
		datos: {
			moneda: 'COP',
			productos: [],
		},
	}),
	props: ['identificador-local', 'solo-lectura'],
	computed: {
		subtotal: function() {
			let s = 0
			for (let p of this.datos.productos) {
				s += Number(p.precioSubtotal)
			}

			return s
		},
		montoDeImpuestos: function() {
			let m = 0
			for (let p of this.datos.productos) {
				m += Number(p.montoDeImpuestos)
			}

			return m
		},
		total: function() {
			return this.subtotal + this.montoDeImpuestos
		}
	},
	watch: {
		'datos.productos': {
			handler: function(productos) {
				for (let i in this.datos.productos) {
					if (this.datos.productos[i].cantidad > this.datos.productos[i].enInventario && !this.soloLectura) {
						notificación.error(`Sólo hay ${this.datos.productos[i].enInventario} unidades disponibles en inventario de «${this.datos.productos[i].descripción}».`)
					}

					let precioSubtotal = (Number(this.datos.productos[i].precioUnitario) * this.datos.productos[i].cantidad)
					let montoDeImpuestos = 0

					for (let j in this.datos.productos[i].impuestos) {
						if (this.datos.productos[i].impuestos[j].porcentaje !== '') {
							let monto = (Number(this.datos.productos[i].impuestos[j].porcentaje) * precioSubtotal / 100)
							this.datos.productos[i].impuestos[j].monto = monto.toString()
							montoDeImpuestos += monto
						}
					}

					this.datos.productos[i].precioSubtotal = precioSubtotal.toString()
					this.datos.productos[i].montoDeImpuestos = montoDeImpuestos.toString()
					this.datos.productos[i].precioTotal = (precioSubtotal + montoDeImpuestos).toString()
				}
				this.$emit('cantidadDeProductos', this.datos.productos.length)
				if (this.identificadorLocal) {
					this.fuente.almacenarBorrador(this.identificadorLocal, this.datos)
				}
			},
			deep: true
		}
	},
	mounted: function() {
		this.definicionesDeImpuestos.inicializar()
	},
	methods: {
		moneda,
		agregarProducto: function(p, opciones) {
			if (!p || !p.identificador) {
				window.alert('[7438] Ocurrió un error')
				return
			} else if (!this.definicionesDeImpuestos.inicializado) {
				window.alert('[7439] Ocurrió un error. Intente nuevamente.')
				return
			}

			for (let i in this.datos.productos) {
				if (this.datos.productos[i].identificador === p.identificador) {
					if (this.datos.productos[i].cantidad >= p.enInventario && !this.soloLectura) {
						notificación.error(`No hay más unidades disponibles en inventario para este producto.`)
					} else {
						this.datos.productos[i].cantidad++
					}
					return
				}
			}

			let impuestos = []
			for (let definición of this.definicionesDeImpuestos.listado) {
				if (definición.identificador === p.definiciónDeImpuestos) {
					impuestos = JSON.parse(JSON.stringify(definición.impuestos))
					for (let j in impuestos) {
						impuestos[j].monto = ''
						impuestos[j].porcentaje = ''
						for (let k in impuestos[j].alternativas) {
							impuestos[j].alternativas[k].text = `${impuestos[j].alternativas[k].porcentaje}%`
						}
						if (!impuestos[j].requerido) {
							impuestos[j].alternativas.push({ porcentaje: '', text: '(No aplica)' })
						}
						if (impuestos[j].alternativas.length === 1) {
							impuestos[j].porcentaje = impuestos[j].alternativas[0].porcentaje
						}
					}
					break
				}
			}

			let producto = Object.assign(JSON.parse(JSON.stringify(p)), {
				identificador: p.identificador,
				impuestos: impuestos,
				cantidad: opciones && opciones.cantidad && opciones.cantidad > 0 ? opciones.cantidad : 1,
				precioUnitario: p.precioUnitario !== undefined ? p.precioUnitario : p.precios[0].monto,
				montoDeImpuestos: '',
				precioSubtotal: p.precioSubtotal !== undefined ? p.precioSubtotal : p.precios[0].monto,
				precioTotal: p.precioTotal !== undefined ? p.precioTotal : p.precios[0].monto
			})

			this.datos.productos.push(producto)
		},
		quitarProducto: function(i) {
			this.datos.productos.splice(i, 1)
		},
		limpiar: function() {
			this.datos.productos = []
		},
		obtenerDatos: function() {
			return {
				moneda: this.datos.moneda,
				productos: this.datos.productos,
				subtotal: this.subtotal,
				montoDeImpuestos: this.montoDeImpuestos,
				total: this.total,
			}
		}
	}
}
</script>

<style scoped>

.cantidad-producto input {
	text-align: right !important;
}

.totales tr > td {
	font-weight: 500;
}

.totales tr > td:last-child {
	padding: 0 10px;
}

.columna-60-100 {
	min-width: 60px;
	max-width: 100px;
}

.miniimagen-descripcion {
	display: flex;
	align-items: center;
}

.miniimagen-descripcion > p {
	margin: 0 5px !important;
}

.miniimagen {
	display: flex;
	flex-shrink: 0;
	align-items: center;
	width: 40px;
	height: 40px
}

</style>
